import { Grid } from "@mui/material";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import {
	useEnvContext,
	useGoogleAnalyticsContext,
	useWebStoreContext
} from "contexts";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import useRewardsById from "hooks/useRewardsById";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { featureTrackerAPI } from "redux/apis";
import { useUpdatePopupStateMutation } from "redux/apis/clubGiftsGalore";
import { onClosePopUp } from "redux/slices";
import {
	Body,
	Button,
	Container,
	FirstTimePurchaseContainer,
	Header,
	StarBurst,
	SubTitle,
	Text,
	Title
} from "./styles";

interface CGGPurchaseSuccessProps {
	tierIndex?: number;
}

export const CGGPurchaseSuccess = ({ tierIndex }: CGGPurchaseSuccessProps) => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const headImageUrl = getImage(
		clubGiftsGaloreAssets.v2.popups.shared.background
	);
	const titleUrl = getImage(clubGiftsGaloreAssets.v2.popups.shared.title);
	const starBurstViolet = getImage(
		clubGiftsGaloreAssets.v2.giftBoxes.starBurstViolet
	);
	const scale = useCalculateScale(363, 485);
	const { authToken } = useWebStoreContext();
	const { syncUserTracker } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	const { reportEvent } = useGoogleAnalyticsContext();
	const [updatePopupState] = useUpdatePopupStateMutation();
	const { data }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	const onClose = () => {
		if (isFirstContribution) {
			updatePopupState({
				popupType: "first-historic-contribution-popup-displayed"
			});
		}
		dispatch(onClosePopUp());
	};

	const { tracker } = data ?? {};
	//const activeTier = tracker?.tiers[tracker?.activeTierIndex];
	const firstTimeContribution = useRewardsById(
		tracker?.firstContributionRewardId as string
	);
	const isFirstContribution =
		isFeatureFlagEnabled(FeaturesFlags.CLUB_GIFT_FIRST_CONTRIBUTION_REWARD) &&
		tracker?.firstContributionRewardId &&
		tracker?.userClubTracker.historicContributionCount === 1 &&
		!tracker?.userEventTracker.popupTrackers
			.firstHistoricContributionPopupDisplayed;
	//const lastTier = tracker?.tiers[tracker?.tiers.length - 1];

	useEffect(() => {
		reportEvent("purchase_success", {
			source: "club_gifts_galore",
			club_gifts_galore_id: tracker?.clubGiftId
		});
	}, []);

	return (
		<Container scale={scale}>
			<Header data-image={headImageUrl}>
				<img src={titleUrl} alt="Club gifts galore" />
			</Header>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					Your gift added progress to Tier {(tierIndex as number) + 1}!
					{/* <br />
					{activeTier === lastTier
						? "Keep contributing to unlock the BIGGEST REWARD!"
						: "Keep going to unlock the next reward!"} */}
					{/* <br /> Check your inbox in the game for
					<br /> your bonus prize! */}
				</Title>
				<Text>
					Your items are waiting in your in-game
					<br /> inbox to be collected!
				</Text>
				{isFirstContribution && (
					<Grid item sx={{ width: "100%" }}>
						<SubTitle style={{ paintOrder: "stroke fill" }}>
							You also got:
						</SubTitle>
						<FirstTimePurchaseContainer>
							<Grid container spacing={2} direction="row" alignItems="center">
								<Grid item position="relative">
									<StarBurst src={starBurstViolet} />
									<img
										src={firstTimeContribution?.[0]?.imageUrl}
										alt="First time contribution image"
										height={47}
									/>
								</Grid>
								<Grid item>
									<Grid container direction="column">
										<SubTitle style={{ paintOrder: "stroke fill" }}>
											First time contribution
										</SubTitle>
										<SubTitle
											color="#FBBD05"
											style={{ paintOrder: "stroke fill" }}
										>
											+
											{`${firstTimeContribution?.[0]?.description} ${
												Number(firstTimeContribution?.[0]?.description) > 1
													? firstTimeContribution?.[0]?.pluralLabel
													: firstTimeContribution?.[0]?.singularLabel
											}`}
										</SubTitle>
									</Grid>
								</Grid>
							</Grid>
						</FirstTimePurchaseContainer>
					</Grid>
				)}
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						//sm={isMobile ? 6 : 12}
						display="flex"
						justifyContent="center"
					>
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
							onClick={() => {
								syncUserTracker();
								onClose();
							}}
						>
							Continue Shopping
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="daily_reward_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
